var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-switch',_vm._b({class:_vm.$attrs.class,style:(_vm.$attrs.style),attrs:{"input-value":_vm.getValue},on:{"change":_vm.updateModelValue}},'v-switch',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }